<template>
    <div v-if="!loading">
        <select-form-group
                v-model="data.legal_text_id"
                name="legal_text_id"
                label="Legal Text"
                :error="(errors.legal_text_id || [])[0]"
                :options="legalTextOptions"
        />
    </div>
</template>

<script>
    import http from '@/http'
    import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'

    export default {
        components: {SelectFormGroup},

        props: {
            value: {
                required: true
            },

            errors: {
                required: true
            }
        },

        data() {
            return {
                legalTexts: null,

                loading: true
            }
        },

        mounted() {
            this.load()
        },

        computed: {
            data: {
                get() {
                    return this.value
                },

                set(value) {
                    this.$emit('input', value)
                }
            },

            legalTextOptions() {
                return this.legalTexts.map(legalText => ({
                    value: legalText.id,
                    label: legalText.attributes.name
                }))
            }
        },

        methods: {
            load() {
                http.get('/api/v2/legal-texts').then(response => {
                    this.legalTexts = response.data.data

                    this.loading = false
                })
            }
        }
    }
</script>
